import { APP_PERMISSIONS } from '@exam-center/permission';
import { NoRowsOverlay, Flex, CampaignOutlinedIcon } from '@shared/components';
import { usePermission } from '@shared/permissions';

import { CreateAnnouncementButton } from '../create-announcement-button';
interface AnnouncementNoRowsOverlayProps {
  openCreateAnnouncementModal: () => void;
}
export default function AnnouncementNoRowsOverlay(props: Readonly<AnnouncementNoRowsOverlayProps>) {
  const { openCreateAnnouncementModal } = props;
  const { permissions } = usePermission();

  return (
    <Flex
      sx={{
        py: (theme) => theme.spacing(20),
      }}
    >
      <NoRowsOverlay
        icon={CampaignOutlinedIcon}
        title='ไม่มีประกาศข่าวสาร'
        description={
          permissions.includes(
            APP_PERMISSIONS.ADMIN_ANNOUNCEMENT_MANAGEMENT.WEB_REGISTER_ANNOUNCEMENT.CREATE,
          )
            ? 'คลิกปุ่มด้านล่างเพื่อสร้างประกาศใหม่'
            : undefined
        }
        action={
          <CreateAnnouncementButton variant='outlined' onClick={openCreateAnnouncementModal} />
        }
        slotProps={{
          wrapper: {
            disablePadding: true,
          },
          icon: {
            fontSize: 100,
          },
        }}
      />
    </Flex>
  );
}
